export default __webpack_public_path__ + "static/media/img18.f15e073f.jpg";